export enum SolutionStatus {
  PUBLISHED = 'published',
  COMING_SOON = 'comingsoon',
}
